import React from "react";
import { useFirebase } from "../contexts/firebase-context";
import { Navigate } from "react-router-dom";
import { Box, Typography } from '@mui/material';

const AuthWrapper = ({ children, page }) => {
    const { isLoading, isLoggedIn, userAccess } = useFirebase()

    if (!isLoading) {
        if (isLoggedIn) {
            if (userAccess[page]) {
                return (
                    <>
                        {children}
                    </>
                )
            }
            else {
                return <Navigate to="/unauthorized" replace={true} />
            }
        }
        else {
            return (
                <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, m: 5, p: 5, textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ fontFamily: 'monospace' }}>Please Sign in to access this feature</Typography>
                </Box>
            )
        }
    }
    else {
        return (
            <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, m: 5, p: 5, textAlign: 'center' }}>
                <Typography variant="h5" sx={{ fontFamily: 'monospace' }}>Loading...</Typography>
            </Box>
        )
    }
}

export default AuthWrapper
